




























































































import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";

import {structureStore} from "@/store/store";
import SeasonRow from "@/modules/perRoad/views/components/SeasonRow.vue";
import {UnitSystem} from "@/interfaces/units";
import {createStructureValidations} from "@/modules/structure/lib/validations";
import PrLayerEditor from "@/modules/perRoad/views/components/structure/PrLayerEditor.vue";
import StructureLayerEditor from "@/modules/structure/views/StructureLayerEditor.vue";
import InspectorThreeJS from "@/modules/perRoad/views/components/inspection/InspectorThreeJS.vue";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import {
  convertDeterministicLayersImperial,
  convertDeterministicLayersMetric
} from "@/modules/structure/lib/convertLayers";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import {loadingPatternOptions} from "@/modules/perRoad/lib/simulation/axleLoadPatterns";
import {perRoadTireLoadImperialToMetric} from "@/modules/perRoad/lib/unitConversion/perRoadConversion";

Component.registerHooks(["validations"]);

@Component({
  components: {
    CriticalLocationLayoutInspector,
    CriticalLocationDepthInspector,
    InspectorThreeJS,
    StructureLayerEditor,
    PrLayerEditor,
    SeasonRow,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PavementStructureLoading extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  plotKey = 0;

  newLayer(n: number, event: any) {
    this.scenario.structureLayers.splice(n, 1, event);
    this.sync();
  }

  setTireLoads() {
    const numTires = this.scenario.loads.length;
    const axleTotalTires = numTires * 2;
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      const loadPerTire = this.scenario.axleLoad_lb / axleTotalTires;
      this.scenario.loads.forEach(load => load.load_lbf = loadPerTire);
    } else {
      const loadPerTire = this.scenario.axleLoad_kg / axleTotalTires;
      this.scenario.loads.forEach(load => load.load_kg = loadPerTire);
    }

    this.sync();
  }

  get scenario() {
    return structureStore.currentScenario;
  }

  get scenarioImperial() {
    return structureStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get simulatedLayers() {
    this.plotKey += 1;
    console.log("creating sim layers");
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return convertDeterministicLayersImperial(this.scenario.structureLayers);
    } else {
      return convertDeterministicLayersMetric(this.scenario.structureLayers);
    }
  }

  get loadingOptions() {
    return [
      {text: "Single Axle, Single Tire", value: "Single Axle, Single Tire"},
      {text: "Single Axle, Double Tire", value: "Single Axle, Double Tire"},
      {text: "Tandem Axle, Double Tire", value: "Tandem Axle, Double Tire"},
      {text: "Tridem Axle, Double Tire", value: "Tridem Axle, Double Tire"},
    ];
  }

  setLoadingPattern() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      this.scenario.loads = JSON.parse(JSON.stringify(loadingPatternOptions[this.scenario.loadPatternName]));
    } else {
      this.scenario.loads = [...loadingPatternOptions[this.scenario.loadPatternName]].map(load => perRoadTireLoadImperialToMetric(load));
    }
    this.sync();
  }

  incrementPlotKey() {
    this.plotKey += 1;
  }

  sync() {
    structureStore.setCurrentScenario(this.scenario);
    this.incrementPlotKey();
  }

  save() {
    this.sync();
    structureStore.saveCurrentScenario();
  }

  validations() {
    return createStructureValidations(this.scenarioImperial, this.page);
  }

  mounted() {
    this.setLoadingPattern();
    this.setTireLoads();
  }
}

